function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, reactive, ref, watch } from "vue";
import { definePropType } from "@types-vue/props";
import SearchBar from "@pt/views/pt-entry/components/search-bar.vue";
import FilterBar from "@pt/views/pt-entry/components/filter-bar/index.vue";
import CreativeAssetsCard from "./creative-assets-card.vue";
import OrderSelect from "@pt/components/order-select.vue";
import SearchInput from "@pt/components/search-input.vue";
import _ from "lodash";
import i18n from "@/lang";
import { filterChange, transformQuery, queryConfig } from "./asset-dialog";
import { assetsList, getAssetRetryTranscode } from "@pt/api/assets";
import { filterSchemaConfig } from "@pt/views/pt-entry/components/filter-bar/filter-model";
import { pauseVideoAudio } from "@com/utils/pause-video-audio";
import { getTransCodeAddPendingId, getTranscodeProgress, updateProgress } from "@pt/utils/assets-transcode";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        checkbox: {
            type: Boolean,
            default: true
        },
        /* 查询 */ model: {
            type: definePropType(Object),
            default: function() {}
        },
        message: {
            type: definePropType(String)
        },
        rules: {
            type: definePropType(Object)
        },
        /* 默认勾选项 */ selection: {
            type: definePropType(Array)
        },
        /* 禁用全部checkbox */ disabledCheckbox: {
            type: Boolean
        },
        // 禁止选中的ID集合
        disabledSelectId: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        // 是否启用跨域
        crossorigin: {
            type: Boolean,
            default: false
        }
    },
    components: {
        SearchBar: SearchBar,
        FilterBar: FilterBar,
        CreativeAssetsCard: CreativeAssetsCard
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var query = reactive(_.cloneDeep(queryConfig));
        var listData = ref([]);
        var multipleSelection = ref([]);
        var listLoading = ref(false);
        var listTotal = ref(0);
        var timer = null;
        var noMore = computed(function() {
            return query.page * query.page_size >= listTotal.value;
        });
        var disabledScroll = computed(function() {
            return listLoading.value || noMore.value;
        });
        var clearList = function() {
            listData.value = [];
            listTotal.value = 0;
        };
        var handleSelectionChange = function(rowList) {
            if (props.checkbox) {
                multipleSelection.value = rowList;
            } else {
                if (rowList.length === 1 || !rowList.length) {
                    multipleSelection.value = rowList;
                } else {
                    multipleSelection.value = [
                        rowList[rowList.length - 1]
                    ];
                }
            }
            emit("change", multipleSelection.value);
        };
        var initListData = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res, transCodeId;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            pauseVideoAudio();
                            // handleSelectionChange([]) // 清空选项
                            listLoading.value = true;
                            _ctx.next = 5;
                            return assetsList(transformQuery(query));
                        case 5:
                            res = _ctx.sent;
                            listLoading.value = false;
                            if (query.page === 1) {
                                listData.value = _.get(res, "data.data.list") || [];
                            } else {
                                listData.value = listData.value.concat(_.get(res, "data.data.list") || []);
                            }
                            listTotal.value = _.get(res, "data.data.total") || 0;
                            transCodeId = getTransCodeAddPendingId(listData.value).transCodeId;
                            // 转码进度查询
                            if (transCodeId.length) {
                                getAssetProgress(transCodeId);
                            }
                            _ctx.next = 16;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }));
            return function initListData() {
                return _ref.apply(this, arguments);
            };
        }();
        var load = function() {
            if (!disabledScroll.value) {
                query.page = query.page + 1;
                initListData();
            }
        };
        var changeSearchBar = function() {
            clearList();
            // 资产搜索时有选中的资源默认勾选
            if (props.selection && props.selection.length) {
                handleSelectionChange(props.selection);
            } else {
                handleSelectionChange([]) // 清空选项
                ;
            }
            initListData();
        };
        var searchFormSchema = [
            {
                type: "object",
                properties: {
                    search_field: {
                        component: "select",
                        class: "search-field",
                        noRefresh: true,
                        field: {
                            options: [
                                {
                                    label: i18n.t("resourceManager.filter.assetName"),
                                    value: "name"
                                },
                                {
                                    label: i18n.t("resourceManager.filter.assetId"),
                                    value: "id"
                                }, 
                            ]
                        }
                    },
                    keyword: {
                        component: SearchInput,
                        class: "search-keyword",
                        field: {
                            placeholder: i18n.t("resourceManager.filter.search")
                        },
                        handleChange: function handleChange() {
                            changeSearchBar();
                        }
                    },
                    order: {
                        component: OrderSelect,
                        class: "select-order",
                        field: {
                            options: [
                                {
                                    label: i18n.t("resourceManager.filter.createTime"),
                                    value: "created_time"
                                },
                                {
                                    label: i18n.t("resourceManager.filter.updateTime"),
                                    value: "updated_time"
                                },
                                {
                                    label: i18n.t("resourceManager.filter.assetName"),
                                    value: "name"
                                },
                                {
                                    label: i18n.t("resourceManager.filter.fileSize"),
                                    value: "file_size"
                                }, 
                            ]
                        },
                        handleChange: function handleChange() {
                            query.page = 1;
                            handleSelectionChange([]) // 清空选项
                            ;
                            initListData();
                        }
                    },
                    formats: filterSchemaConfig.formats,
                    types: filterSchemaConfig.types
                }
            }, 
        ];
        watch(function() {
            return props.visible;
        }, function(val) {
            listData.value = [];
            listTotal.value = 0;
            pauseVideoAudio();
            handleSelectionChange([]);
            if (val) {
                Object.assign(query, _objectSpread({}, queryConfig));
                Object.assign(query, _objectSpread({}, props.model));
                initListData();
            }
        }, {
            immediate: true
        });
        watch(function() {
            return props.selection;
        }, function(val) {
            multipleSelection.value = _.cloneDeep(val);
        }, {
            immediate: true
        });
        var handleFilterChange = function(data) {
            clearList();
            handleSelectionChange([]) // 清空选项
            ;
            Object.assign(query, _objectSpread({}, filterChange(data, query)));
            initListData();
        };
        function getAssetProgress(transCodeId) {
            return _getAssetProgress.apply(this, arguments);
        }
        function _getAssetProgress() {
            _getAssetProgress = _asyncToGenerator(regeneratorRuntime.mark(function _callee(transCodeId) {
                var _$ref, data, update;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            timer && clearTimeout(timer);
                            if (props.visible) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return", false);
                        case 3:
                            _ctx.next = 5;
                            return getTranscodeProgress(transCodeId);
                        case 5:
                            _$ref = _ctx.sent;
                            data = _$ref.data;
                            update = _$ref.update;
                            if (!update) {
                                _ctx.next = 13;
                                break;
                            }
                            query.page = 1;
                            clearList();
                            initListData();
                            return _ctx.abrupt("return", false);
                        case 13:
                            listData.value = updateProgress(listData.value, data);
                            timer = setTimeout(function() {
                                getAssetProgress(transCodeId);
                            }, 3000);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getAssetProgress.apply(this, arguments);
        }
        // 转码失败重试
        var retryEvent = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(id) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return getAssetRetryTranscode(id);
                        case 3:
                            query.page = 1;
                            clearList();
                            initListData();
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }));
            return function retryEvent(id) {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            query: query,
            listData: listData,
            listLoading: listLoading,
            listTotal: listTotal,
            multipleSelection: multipleSelection,
            searchFormSchema: searchFormSchema,
            disabledScroll: disabledScroll,
            load: load,
            handleFilterChange: handleFilterChange,
            handleSelectionChange: handleSelectionChange,
            changeSearchBar: changeSearchBar,
            retryEvent: retryEvent
        };
    }
});
